// extracted by mini-css-extract-plugin
export default {"flex":"language-switcher_flex__XSXCB","marginX":"language-switcher_marginX__Fxshj","secondary":"language-switcher_secondary__gTJxW"};